var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5747"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 806",
    d: "M13.08 2.986a21 21 0 00-1.976 2.108 27.277 27.277 0 00-3.493-3.908c-3.454 3.205-5.906 7.381-5.906 9.9a7.99 7.99 0 007.875 8.1 7.99 7.99 0 007.875-8.1c0-1.873-1.827-5.735-4.375-8.1zm-.684 11.976a4.725 4.725 0 01-2.715.849 4.329 4.329 0 01-4.6-4.4c0-1.357.855-2.553 2.559-4.6.244.281 3.474 4.406 3.474 4.406l2.061-2.351c.146.241.278.476.4.7a4.193 4.193 0 01-1.179 5.396z"
  }))));
}
export default SvgHot;